export class PrivateTalk {

  constructor(
    public isStarted: boolean,
    public participants: { [key: number]: { wasMuted: boolean }},
    public isPrivateWhiteboardOn: boolean
  ) {}
}
